export const LOGIN_SUCCESS = 'action/login/success';
export const LOGIN_FAIL = 'action/login/fail';
export const SIGNUP_SUCCESS = 'action/signup/success';
export const SIGNUP_FAIL = 'action/signup/fail';
export const RESET_USER_DATA = 'action/reset';
export const LOGOUT_FAIL = 'acion/logout/fail'